let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("9CYYI")).then(() => parcelRequire('c3FF8'));